// extracted by mini-css-extract-plugin
export var container = "styles-module__container___gunN4";
export var header = "styles-module__header___s3fKV";
export var label = "styles-module__label___i9SJ4";